import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { UserContext } from '../App';

/**
 * Simple context switcher for dual users (Owner vs Nominee).
 *
 * Note: This updates server-side preferences via POST /auth/switch-role.
 */
export default function ContextSwitcher({ style = {} }) {
  const { currentUser, setCurrentUser } = useContext(UserContext);
  const navigate = useNavigate();

  const available = Array.isArray(currentUser?.availableContexts) ? currentUser.availableContexts : null;
  if (!available || available.length < 2) return null;

  const value = currentUser?.type === 'nominee' ? 'nominee' : 'owner';

  return (
    <select
      aria-label="Switch context"
      value={value}
      onChange={async (e) => {
        const next = e.target.value;
        try {
          const payload = { active_context: next };
          if (next === 'nominee' && currentUser?.activeOwnerSub) {
            payload.active_owner_sub = currentUser.activeOwnerSub;
          }
          const resp = await api.post('/auth/switch-role', payload);
          const updated = {
            ...currentUser,
            type: resp?.data?.activeContext || next,
            activeOwnerSub: resp?.data?.activeOwnerSub ?? currentUser?.activeOwnerSub ?? null,
          };
          setCurrentUser(updated);
          try { localStorage.setItem('currentUser', JSON.stringify(updated)); } catch {}

          if (next === 'nominee') navigate('/nominee');
          else navigate('/dashboard');
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error('Failed to switch context:', err?.response?.data || err);
        }
      }}
      style={{
        padding: '6px 10px',
        borderRadius: 10,
        border: '1px solid var(--mist-300)',
        background: '#fff',
        ...style,
      }}
    >
      <option value="owner">Owner view</option>
      <option value="nominee">Nominee view</option>
    </select>
  );
}





